import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard, GuestGuard, HomeRedirect } from '@shared/guards';

const routes: Routes = [
    {
        path: '',
        redirectTo: '',
        pathMatch: 'full',
        canActivate: [HomeRedirect],
        data: {
            title: 'Home'
        }
    },


    /**
     * Member Area
     */
    {
        path: 'membership-card',
        loadChildren: () => import('@pages/member/membership-card/membership-card.module').then(m => m.MembershipCardPageModule),
        data: {
            title: 'membership-card.title'
        }
    },

];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule { }
